var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_user-agent.js
// module id = 654
// module chunks = 168707334958949